import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-role',
  templateUrl: './service-role.component.html',
  styleUrls: ['./service-role.component.scss']
})
export class ServiceRoleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
